import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableProps } from 'rsuite/lib/Table';
import { RootState } from '../../@types/RootState';

export type GetClusterStoreModalPaginationStateSortState<K extends TableProps['sortColumn'] = string> = {
  type: K;
  orderBy: TableProps['sortType'];
};

const initialState: GetClusterStoreModalPaginationStateSortState = {
  type: 'productIds',
  orderBy: 'asc',
};

const slice = createSlice({
  name: 'getClusterStoreModal/sort',
  initialState,
  reducers: {
    SET_GET_CLUSTER_STORE_MODAL_SORT: (_state, { payload }: PayloadAction<GetClusterStoreModalPaginationStateSortState>) => payload,
    RESET_GET_CLUSTER_STORE_MODAL_SORT: () => initialState,
  },
});

export const { SET_GET_CLUSTER_STORE_MODAL_SORT, RESET_GET_CLUSTER_STORE_MODAL_SORT } = slice.actions;

export const selectorGetClusterStoreModalSort = (state: RootState) => {
  return state.getClusterStoreModalReducer.sort;
};

export default slice.reducer;
